import React from "react";
import { __ } from "services/Translator";

// Attachments are gated twice: on features.attachments from widget-config, and
// on the upload route actually existing. POST /conversations/{ref}/attachments
// is deferred to W0.7 and is deliberately not registered, so even with the
// feature flag on there is nowhere to upload to yet.
//
// Rather than render a picker that would 404 on submit, the control renders
// disabled with an honest reason. When W0.7 lands this becomes a real input and
// nothing else in the composer has to move.
export default function AttachmentButton({ enabled }) {
  if (!enabled) {
    return null;
  }

  return (
    <button
      type="button"
      className="supIconBtn supAttach"
      disabled
      title={__("Attachments are not available yet")}
      aria-label={__("Attachments are not available yet")}
    >
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">
        <path
          d="M8 12.5l6-6a3 3 0 114.2 4.2l-7.5 7.5a5 5 0 11-7-7l7-7"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}
